/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import LoadingSpinner from 'DesignSystem/LoadingSpinner/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/Action/Letter/Edit/RegenerateLetterModal/Content/SubmitAction"
  
}) {
let loadingValueData = fromData.useDataValue({ viewPath,
context: 'loading',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let loadingValueData1 = fromData.useDataValue({ viewPath,
context: 'loading',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 onClick={onClick}
 marginLeft={dtSpaceXs}
 data="loading"
 disabled={loadingValueData}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Regenerate letter"
/>
<fromFlow.When is={loadingValueData1}>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 data="loading"
>
{childProps => (
<LoadingSpinner
{...childProps}
  viewPath={`${viewPath}/LoadingSpinner`}
 height={16}
 width={16}
/>
)}
</TysiaButtonIcon>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}